<template>
  <div>
    <el-input
      :clearable="clearable"
      @focus="showSelect()"
      ref="dsi"
      @clear="clearHandle()"
      :disabled="disabled"
      v-model="submitPathTextName">
    </el-input>

    <el-dialog
      append-to-body
      :visible.sync="visible"
      width="40%"
      append-to-body>

      <!-- 展示选中路径-->
      <div style="font-size: 15px; text-align: center; margin-top: 15px; margin-bottom: 20px;">
        <template v-if="title">
          <span v-html="title" ></span>
        </template>
        <template v-else>
          <span v-html="dictionaryName" ></span>
        </template>
        <span class="required" v-if="required">*</span>
      </div>

      <el-row>
        <el-col :span="24">
          <el-card shadow="never" class="tree-card">
            <div slot="header" style="text-align: center">
              <span>{{pathTextName}}</span>
            </div>

            <div class="card-tree" style="margin-bottom: 20px">
              <tree ref="tree" :data="selectData" @handleNodeClick="handleNodeClick" :filter="filter" :value="value" :props="props"></tree>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitHandle()">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import DIC_API from "../../api/api_dictionary";
import tree from "@/components/training/tree/tree";

export default {
  name: "dictionarySelect",
  components: {tree},
  props: {
    /**
     * 父级字典编码
     */
    parentCode: {
      type: String
    },
    /**
     * 弹出框标题（不填默认为 字典名称）
     */
    title: {
      type: String,
      default:()=> {
        return undefined;
      }
    },
    /**
     * 是否可清空选项
     * */
    clearable:{
      type: Boolean,
      default:()=>{ return false }
    },
    /**
     * 不可选
     * */
    disabled:{
      type:Boolean,
      default:()=>{ return false }
    },
    /**
     * 是否必选
     */
    required: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    /**
     * 是否开启搜索
     */
    filter: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },

  data() {
    return {
      // tree props
      props: {
        value: 'code',              // ID字段名
        label: 'text',         // 显示名称
        children: 'children'    // 子级字段名
      },
      /**
       * 默认选中值
       */
      value: undefined,
      /**
       * 字典名称
       */
      dictionaryName: undefined,
      /**
       * 是否展示弹出层
       */
      visible: false,
      /**
       * 选择数据
       */
      selectData: [],
      /**
       * 路径字段文本名称 （点击确定后）
       */
      submitPathTextName: undefined,
      /**
       * 路径字段文本名称
       */
      pathTextName: undefined,
      /**
       * 文本名称
       */
      textName: undefined,
      /**
       * 选中节点
       */
      node: undefined,
      /**
       * 选中节点组件
       */
      componentInit: undefined,
      /**
       * 是否设置选中
       */
       isSetChecked: false
    }
  },
  methods: {
    /**
     * 处理取消选中
     */
    cancelHandle() {

    },
    /**
     * 处理确定
     */
    submitHandle() {
      if (this.required) {
        if (this.node == undefined){
          this.$message.error('请选择' + this.dictionaryName);
          return;
        }
      }

      if (this.node) {
        this.$emit('submit', {
          pathTextName: this.pathTextName,
          textName: this.textName,
          node: this.componentInit,
          value: this.componentInit.data.id
        });
        this.submitPathTextName = this.pathTextName;
      } else {
        this.$emit('submit', null);
        this.submitPathTextName = undefined;
      }
      this.visible = false;
    },
    /**
     * 设置选中
     */
    setChecked(code, pathTextName) {
      this.loadSelectData();
      this.value = code;
      this.isSetChecked = true;
      this.submitPathTextName  = pathTextName;
    },
    /**
     * 处理选中
     */
    handleNodeClick(node, componentInit){
      if (node) {
        this.textName = node.object.text;
        this.pathTextName = this.nodeText(componentInit);
        this.componentInit = componentInit;
        this.node = node;

        if (this.isSetChecked) {
          this.submitPathTextName = this.pathTextName;
          this.isSetChecked = false;
        }
      } else {
        this.node = undefined;
        this.textName = undefined;
        this.pathTextName = undefined;
      }
    },
    /**
     * node path text
     */
    nodeText(node) {
      if (node.parent && node.parent.level >= 1) {
        return this.nodeText(node.parent) + "-" + node.data.text;
      } else {
        return node.data.text;
      }
    },
    /**
     * 展示弹出选择层
     */
    showSelect() {
      this.$refs.dsi.blur();
      this.visible = true;
    },
    /**
     * 数据清空事件
     */
    clearHandle() {
      this.pathTextName = undefined;
      this.submitPathTextName = undefined;
      this.node = undefined;
      this.componentInit = undefined;
      this.textName = undefined;
      this.$refs.tree.clearHandle();
      this.$emit('submit', null);
    },
    /**
     * 清空数据
     */
    clear(){
      this.clearHandle();
    },
    /**
     * 加载选择数据
     * */
    loadSelectData() {
      DIC_API.getDictionaryResolveToTree({
        code: this.parentCode
      }).then((res) => {
        if (res && res.data) {
          this.dictionaryName  = res.data.text + '选择';
          this.selectData = res.data.children;
        }
      });
    }
  },
  created() {
    this.loadSelectData();
  }
}
</script>

<style scoped>
  .tree-card {
    height: 460px;
  }

  .card-tree {
    height: 350px;
  }

  .el-scrollbar__wrap {
    overflow-x: hidden;

  }
  .required {
    color: red;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/dictionarySelect.vue